<template>
    <div class="setting-icon">
        <div :class="innerConfig.class ? {} : {'setting-title': true}" @click="visible = !visible">
            <i class="el-icon-setting"/>
        </div>
        <el-dialog
            title="设置列的显示/排序"
            :visible="visible"
            :before-close="handleCancel"
            custom-class="custom-dialog"
            append-to-body
        >
            <el-row :gutter="20" class="content">
                <el-col v-if="innerConfig.visibility" :span="16" class="section">
                    <div class="section-title">全部字段</div>
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                    >全选</el-checkbox>
                    <div class="section-content">
                        <el-checkbox-group v-model="checkedList" @change="handleCheckedListChange">
                            <el-checkbox
                                v-for="{ prop, label, setDisabled} in columns"
                                :label="prop"
                                :key="prop"
                                :disabled="!!setDisabled"
                            >{{ label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-col>
                <el-col v-if="innerConfig.sorting && !isCreamOn" :span="8">
                    <div class="section-title">已选字段</div>
                    <div class="section-content">
                        <div
                            class="drag-item"
                            v-for="(prop, index) in checkedList"
                            :key="index"
                            v-dragging="{ item: prop, list: checkedList, group: 'prop' }"
                        >
                            <span>
                                <i class="el-icon-more icon-drag"></i>
                                {{ columnMap[prop].label }}
                            </span>
                            <i class="el-icon-close icon-close" @click="handleUnselect(prop)" v-if="!columnMap[prop].setDisabled"></i>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="handleSuccess">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep } from '@lsfe/tools';
import { detectDeviceType } from '../../utils/tools';

export default {
    props: {
        columns: {
            type: Array,
            default: () => []
        },
        config: {
            type: Object,
            default: () => ({})
        },
        saveHandler: Function
    },
    data() {
        return {
            visible: false,
            checkAll: false,
            checkedList: [], // 已选中列表
            columnMap: {},
            isIndeterminate: false,
            isMobile: detectDeviceType() === 'Mobile'
        };
    },
    computed: {
        innerConfig() {
            return Object.assign(
                {
                    visibility: true,
                    sorting: true
                },
                this.config
            );
        },
        isCreamOn() {
            return this.$mcCream && this.$mcCream.isCreamOn;
        },
    },
    watch: {
        columns: {
            immediate: true,
            handler() {
                this.columns.forEach(col => {
                    this.columnMap[col.prop] = cloneDeep(col);
                });
                this.reset();
            }
        }
    },
    methods: {
        reset() {
            const checkedList = [];
            let columnsTmp = cloneDeep(this.columns);
            columnsTmp.forEach(col => {
                const { visible = true, prop } = col;
                visible && checkedList.push(prop);
            });
            // this.$emit('11323sd', columnsTmp);

            this.checkedList = checkedList;
            this.handleCheckedListChange(checkedList);
        },
        /**
         * 在已选字段里点击x删除
         * @param val
         */
        handleUnselect(val) {
            this.checkedList = this.checkedList.filter(prop => prop !== val);
        },
        /**
         * 面板点击取消
         */
        handleCancel() {
            this.visible = false;
            this.reset();
        },
        /**
         * 面板点击确定，进行保存
         */
        handleSuccess() {
            this.visible = false;
            const unsortedList = [];
            let columnsTmp = cloneDeep(this.columns);

            columnsTmp.forEach(col => {
                const visible = this.checkedList.includes(col.prop);
                this.columnMap[col.prop].visible = visible; // 更新列是否可见
                !visible && unsortedList.push(this.columnMap[col.prop]); // 不可见的列不参与排序
            });

            const sortedList = this.checkedList.map(prop => this.columnMap[prop]);
            this.saveHandler && this.saveHandler([...sortedList, ...unsortedList]);
        },
        /**
         * 点击全选
         */
        handleCheckAllChange(val) {
            let emptyColumns = [];
            const setDisabledColumns = this.columns.filter(v => v.setDisabled);
            if(setDisabledColumns.length) {
                emptyColumns = setDisabledColumns.map(v => v.prop);
            }
            this.checkedList = val ? this.columns.map(col => col.prop) : emptyColumns;
            this.isIndeterminate = false;
        },
        /**
         * 全部字段里选择发生变化时
         * @param value
         */
        handleCheckedListChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.columns.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.columns.length;
        }
    }
};
</script>

<style lang="scss" scoped>
.setting-icon {
    display: inline-block;
    margin-left: 8px;
    vertical-align: middle;
}
.setting-title {
    font-size: 22px;
    font-weight: lighter;
    // border: 1px solid black;
    // border-radius: 2px;
    height: 22px;
    width: 22px;
    line-height: 22px;
    cursor: pointer;
    text-align: center;
}
.content {
    display: flex;
    min-height: 310px;
}
.custom-dialog {
    padding: 20px 10px;
}
.section {
    border-right: 1px solid #eee;
}

.section-title {
    height: 40px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    line-height: 40px;
    margin-bottom: 10px;
}
.section-content {
    max-height: 350px;
    overflow-y: auto;
}
.drag-item {
    padding: 0 10px 0 5px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    cursor: move;
    align-items: center;
    &:hover {
        background: rgba(#409eff, 0.08);
    }
}
.icon-close {
    cursor: pointer;
}
.icon-drag {
    transform: rotate(90deg);
}

</style>
